<template>
  <div class="user-small-layout">
    <header v-if="!hideLogo" class="user-small-layout-header">{{tip}}</header>
    <div class="user-small-layout-content">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'mSmallLayout',
  props: {
    tip: { type: String, default: '欢迎注册《中国社区发展网》' },
    hideLogo: { type: Boolean, default: false }
  },
  setup () {}
}
</script>
